<template>
  <v-dialog v-model="opened" :transition="false" :max-width="600" :persistent="false">
    <ProgressCircular v-if="$apollo.queries.profileDetail.loading" />
    <v-container v-else>
      <v-card>
        <v-card-title class="headline">Информация о партнере</v-card-title>
        <v-card-text v-if="returnDetailsEntityType">
          <v-row>
            <v-col>
              <span>Тип партнера</span>
              <v-text-field outlined dense disabled :value="returnDetailsEntityType.title" />
            </v-col>
          </v-row>
          <template v-if="returnDetailsEntityType.value === 'PERSONAL'">
            <v-row v-if="profileDetail.surname">
              <v-col>
                <span>Фамилия</span>
                <v-text-field outlined dense disabled :value="profileDetail.surname" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.name">
              <v-col>
                <span>Имя</span>
                <v-text-field outlined dense disabled :value="profileDetail.name" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.patronymic">
              <v-col>
                <span>Отчество</span>
                <v-text-field outlined dense disabled :value="profileDetail.patronymic" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.phone">
              <v-col>
                <span>Телефон</span>
                <v-text-field outlined dense disabled :value="profileDetail.phone" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.email">
              <v-col>
                <span>Эл. почта</span>
                <v-text-field outlined dense disabled :value="profileDetail.email" />
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row v-if="profileDetail.orgType">
              <v-col cols="12">
                <span>Форма предприятия</span>
                <v-text-field outlined dense disabled :value="profileDetail.orgType" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.title">
              <v-col cols="12">
                <span>Название организации</span>
                <v-text-field outlined dense disabled :value="profileDetail.title" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.surname">
              <v-col cols="12">
                <span>Фамилия</span>
                <v-text-field outlined dense disabled :value="profileDetail.surname" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.name">
              <v-col cols="12">
                <span>Имя</span>
                <v-text-field outlined dense disabled :value="profileDetail.name" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.patronymic">
              <v-col cols="12">
                <span>Отчество</span>
                <v-text-field outlined dense disabled :value="profileDetail.patronymic" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.position">
              <v-col cols="12">
                <span>Должность</span>
                <v-text-field outlined dense disabled :value="profileDetail.position" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.phone">
              <v-col cols="12">
                <span>Номер телефона для связи</span>
                <v-text-field outlined dense disabled :value="profileDetail.phone" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.email">
              <v-col cols="12">
                <span>Эл.почта</span>
                <v-text-field outlined dense disabled :value="profileDetail.email" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.inn">
              <v-col cols="12">
                <span>ИНН организации</span>
                <v-text-field outlined dense disabled :value="profileDetail.inn" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.ogrn">
              <v-col cols="12">
                <span>ОГРН (ОГРНИП)</span>
                <v-text-field outlined dense disabled :value="profileDetail.ogrn" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.legalAddress">
              <v-col cols="12">
                <span>Юридический адрес</span>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="profileDetail.legalAddress"
                />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.mailAddress">
              <v-col cols="12">
                <span>Почтовый адрес</span>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="profileDetail.mailAddress"
                />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.bank">
              <v-col cols="12">
                <span>Банк</span>
                <v-text-field outlined dense disabled :value="profileDetail.bank" />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.checkingAcc">
              <v-col cols="12">
                <span>Расчетный счет</span>
                <v-text-field
                  outlined
                  dense
                  disabled
                  :value="profileDetail.checkingAcc"
                />
              </v-col>
            </v-row>
            <v-row v-if="profileDetail.bic">
              <v-col cols="12">
                <span>БИК банка</span>
                <v-text-field outlined dense disabled :value="profileDetail.bic" />
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <slot name="actions">
            <v-spacer></v-spacer>
            <v-btn text color="primary darken-2" @click="close()">OK</v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import detailsEntityTypes from '@/configs/detailsEntityTypes'

import DialogAbstract from '@/components/abstract/dialog'
import ProgressCircular from '@/components/progress-circular'

import legalDetailQuery from '@/services/gql/types/LegalDetail/queries/legalDetail.graphql'
import personalDetailQuery from '@/services/gql/types/PersonalDetail/queries/personalDetail.graphql'

export default {
  name: 'ProfileForm',
  components: {
    ProgressCircular
  },
  extends: DialogAbstract,
  props: {
    detailsEntityType: {
      type: String,
      default: null
    },
    profileId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      profileDetail: null
    }
  },
  computed: {
    returnDetailsEntityType () {
      if (!this.detailsEntityType) return null
      return (
        detailsEntityTypes?.find(
          detailType => detailType?.value === this.detailsEntityType
        ) || null
      )
    }
  },
  apollo: {
    profileDetail: {
      fetchPolicy: 'network-only',
      query () {
        if (this.returnDetailsEntityType?.value === 'LEGAL') return legalDetailQuery
        else if (this.returnDetailsEntityType?.value === 'PERSONAL') {
          return personalDetailQuery
        }
      },
      skip () {
        return !this.profileId
      },
      variables () {
        return {
          where: {
            id: Number(this.profileId)
          }
        }
      },
      update (data) {
        if (this.returnDetailsEntityType?.value === 'LEGAL') return data.legalDetail
        if (this.returnDetailsEntityType?.value === 'PERSONAL') return data.personalDetail
      }
    }
  }
}
</script>

<style>
</style>
